import React from 'react';
import { IconSvgProps } from '@models/common';

const DislikeFilled: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22 15H19V3H22C22.2652 3 22.5196 3.10536 22.7071 3.29289C22.8946 3.48043 23 3.73478 23 4V14C23 14.2652 22.8946 14.5196 22.7071 14.7071C22.5196 14.8946 22.2652 15 22 15ZM16.707 16.293L10.307 22.693C10.2219 22.7783 10.1089 22.83 9.98878 22.8387C9.86862 22.8473 9.74939 22.8123 9.653 22.74L8.8 22.1C8.5631 21.9222 8.38416 21.6781 8.28575 21.3987C8.18733 21.1193 8.17385 20.8171 8.247 20.53L9.4 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V11.896C0.999731 11.6346 1.05069 11.3758 1.15 11.134L4.246 3.62C4.32128 3.43675 4.4493 3.28 4.6138 3.16961C4.77831 3.05923 4.97189 3.0002 5.17 3H16C16.2652 3 16.5196 3.10536 16.7071 3.29289C16.8946 3.48043 17 3.73478 17 4V15.586C16.9999 15.8512 16.8946 16.1055 16.707 16.293Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default DislikeFilled;
